import React, { useEffect } from 'react';
import './App.css';
import AppRoutes from './routes/Routes';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { toast } from 'react-toastify';

export const getToken = (): string | null => {
  const token = localStorage.getItem('access_token');
  return token && token !== 'undefined' ? token : null;
};

const App: React.FC = () => {
  const navigate = useNavigate();
  const { dispatch } = useAuth();

  useEffect(() => {
    const token = getToken();
    const storedUser = localStorage.getItem("user_account");

    if (!token) {
      navigate('/login');
    } else if (storedUser) {
      dispatch({ type: "LOGIN", payload: { account: JSON.parse(storedUser) } });
    }

    // const interval = setInterval(() => {
    //   const newToken = getToken();
    //   if (!newToken) {
    //     toast.error("Session expired. Redirecting to login...", { autoClose: 2000 });
    //     localStorage.clear();
    //     navigate("/login");
    //   }
    // }, 1000 * 60 * 15); 

    // return () => clearInterval(interval);
  }, [navigate, dispatch]);

  return <AppRoutes />;
};

export default App;
